(function () {

    if (window.cartReservationLoaded) return;
    window.cartReservationLoaded = true;

    let interval = null;

    const STORAGE_START = "cart_reservation_start";
    const STORAGE_SIGNATURE = "cart_reservation_signature";

    window.initReservationTimer = function () {

        const settings = window.cartReservationSettings;

        if (!settings) return;

        if (interval) {
            clearInterval(interval);
            interval = null;
        }

        const banners = document.querySelectorAll(".cart-hold-banner");

        if (!banners.length) return;

        if (settings.itemCount == 0) {

            banners.forEach(banner => banner.hidden = true);

            localStorage.removeItem(STORAGE_START);
            localStorage.removeItem(STORAGE_SIGNATURE);

            return;
        }

        banners.forEach(banner => banner.hidden = false);

        const previousSignature = localStorage.getItem(STORAGE_SIGNATURE);

        if (previousSignature !== settings.signature) {

            localStorage.setItem(STORAGE_SIGNATURE, settings.signature);
            localStorage.setItem(STORAGE_START, Date.now());

        } else if (!localStorage.getItem(STORAGE_START)) {

            localStorage.setItem(STORAGE_START, Date.now());

        }

        const totalSeconds = settings.minutes * 60;

        function pad(n) {
            return String(n).padStart(2, "0");
        }

        function renderExpired() {

            banners.forEach(banner => {

                banner.classList.add("cart-hold-banner--expired");

                const message = banner.querySelector(".cart-hold-message");
                const timer = banner.querySelector(".cart-hold-timer");

                if (message)
                    message.textContent = settings.expiredText;

                if (timer)
                    timer.remove();

            });

        }

        function tick() {

            const started = Number(localStorage.getItem(STORAGE_START));

            if (!started) return;

            const elapsed = Math.floor((Date.now() - started) / 1000);

            const remaining = totalSeconds - elapsed;

            if (remaining <= 0) {

                clearInterval(interval);

                renderExpired();

                return;

            }

            const minutes = Math.floor(remaining / 60);
            const seconds = pad(remaining % 60);

            banners.forEach(banner => {

                banner.classList.remove("cart-hold-banner--expired");

                const timer = banner.querySelector(".cart-hold-timer");

                if (timer) {
                    timer.textContent = `${minutes}:${seconds}`;
                }

            });

        }

        tick();

        interval = setInterval(tick, 1000);

    };

    window.initReservationTimer();

})();